import {Field} from 'formik';

import {
    FormikTextarea,
    FormikTextInput,
    PlatformFieldset
} from '@flexinet/ui-components';
import {AccountsAutocomplete} from "../../accounts/inputs/AccountsAutocomplete.tsx";
import {Stack} from '@mantine/core';


export const FormComponent = () => {

    return (
        <Stack gap={'xl'}>
            <PlatformFieldset legend={'Organization Details'}>
                <Field
                    name='name'
                    label='Name'
                    description='Please enter the organization name'
                    component={FormikTextInput}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='description'
                    label='Description'
                    description='Please enter organization description'
                    component={FormikTextarea}
                    my={'xl'}
                />

            </PlatformFieldset>

            <PlatformFieldset legend={'Administration'}>
                <Field
                    name='adminAccountId'
                    label='Admin Account'
                    component={AccountsAutocomplete}
                    withAsterisk
                    my={'xl'}
                />

            </PlatformFieldset>

            <PlatformFieldset legend={'Contact'}>
                <Field
                    name='email'
                    label='Email'
                    description='Please enter organization email'
                    component={FormikTextInput}
                    my={'xl'}
                />
                <Field
                    name='phone'
                    label='Phone'
                    description='Please enter organization phone number'
                    component={FormikTextInput}
                    my={'xl'}
                />
                <Field
                    name='url'
                    label='URL'
                    description='Please enter organization URL'
                    component={FormikTextInput}
                    my={'xl'}
                />
            </PlatformFieldset>

        </Stack>
    );
};
